import { Dispatch, SetStateAction } from "react";
import { buildFinishLoading } from "./buildFinishLoading";
import { BeginLoadingInput, State } from "../hooks/useAsyncLoader";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { useDismissToast } from "../../common/hooks/useDismissToast";

export function buildBeginLoading<T>(
  setLoading: Dispatch<SetStateAction<State>>,
  setData: Dispatch<SetStateAction<"initial" | T>>,
  key: DataTestids,
  dismissToast: ReturnType<typeof useDismissToast>
) {
  return function beginLoading(beginLoadingInput?: BeginLoadingInput) {
    setLoading({ tag: "loading", key });
    return buildFinishLoading(
      setLoading,
      setData,
      key,
      dismissToast,
      beginLoadingInput
    );
  };
}
